module.exports = __webpack_public_path__ + "static/img/3.998c083.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mOfficial/3.png
// module id = NFmp
// module chunks = 1